const reviews = [
  { quote: "Spotless, beautifully styled, and the check-in was seamless. Would book again in a heartbeat.", name: "James W", detail: "Stayed in Ancoats" },
  { quote: "The communication was incredible. We had a question at 10pm and got a reply in two minutes.", name: "Priya S", detail: "Stayed in Castlefield" },
  { quote: "Felt like a hotel but with way more space and character. The location was perfect for the AO Arena.", name: "Tom B", detail: "Stayed in the Northern Quarter" },
  { quote: "Clean, comfortable, and the host left great local tips. Will definitely be back.", name: "Sarah M", detail: "Stayed in Salford" },
  { quote: "Best Airbnb we've stayed in. The attention to detail was outstanding from start to finish.", name: "David K", detail: "Stayed in Didsbury" },
  { quote: "Smooth check-in, spotless apartment, and a great location. Five stars all round.", name: "Emma L", detail: "Stayed in Chorlton" },
  { quote: "The little touches made all the difference. Coffee, fresh towels, a welcome note. Felt like home.", name: "Michael R", detail: "Stayed in Deansgate" },
  { quote: "Booked for a work trip and ended up extending. Fast Wi-Fi, quiet building, perfect setup.", name: "Lisa T", detail: "Stayed in Spinningfields" },
];

function Stars() {
  return (
    <div style={{ display: "flex", gap: 2, marginBottom: 10 }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill="#CD533B" stroke="#CD533B" strokeWidth="1.5">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

export default function GuestReviewCarousel() {
  const allReviews = [...reviews, ...reviews];

  return (
    <div className="guest-carousel-viewport" style={{ overflow: "hidden", position: "relative" }}>
      <div className="guest-carousel-track" style={{ display: "flex", width: "max-content" }}>
        {allReviews.map((g, i) => (
          <div key={i} className="guest-carousel-card" style={{ width: 300, marginRight: 16, flexShrink: 0, background: "#fff", border: "1px solid #E8E4D5", borderRadius: 14, padding: "24px 22px", display: "flex", flexDirection: "column", boxSizing: "border-box" }}>
            <Stars />
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "#112215", lineHeight: 1.65, flex: 1, marginBottom: 16, marginTop: 0 }}>&ldquo;{g.quote}&rdquo;</p>
            <div>
              <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 13, color: "#112215", margin: 0 }}>{g.name}</p>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "#5C7268", margin: "2px 0 0" }}>{g.detail}</p>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes guest-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .guest-carousel-track {
          animation: guest-scroll 45s linear infinite;
        }
        .guest-carousel-viewport {
          -webkit-mask-image: linear-gradient(to right, transparent 0%, black 4%, black 96%, transparent 100%);
          mask-image: linear-gradient(to right, transparent 0%, black 4%, black 96%, transparent 100%);
        }
        @media (max-width: 768px) {
          .guest-carousel-card { width: 260px !important; }
        }
      `}</style>
    </div>
  );
}